<app-today-tomorrow-loader [show]="$loading | async" />
@let sportFilters = sportFilters$ | async;
@if (!($loading | async)) {
  <app-sport-filter
    (handleFilter)="filterBySport($event)"
    [filterItems]="sportFilters ?? []"
  />
}
@if (markets.length > 0) {
  <app-m-table [data]="markets" />
}
@if (markets?.length === 0 && !($loading | async)) {
  <app-alert
    [config]="{
      title: 'No Events for Tomorrow.',
      subtitle: 'There are no events for tomorrow.',
      type: 'info'
    }"
  />
}
